import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "rrbros_admin_token";

export const getAdminToken = () => sessionStorage.getItem(TOKEN_KEY) || "";
export const setAdminToken = (token) => sessionStorage.setItem(TOKEN_KEY, token);
export const clearAdminToken = () => sessionStorage.removeItem(TOKEN_KEY);

const authHeader = () => {
  const t = getAdminToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const adminLogin = async (email, password) => {
  const { data } = await axios.post(`${API}/admin/login`, { email, password });
  setAdminToken(data.token);
  return data;
};

export const adminMe = async () => {
  const { data } = await axios.get(`${API}/admin/me`, { headers: authHeader() });
  return data;
};

export const adminGetBookingStatus = async () => {
  const { data } = await axios.get(`${API}/booking-status`);
  return !!data.online;
};

export const adminSetBookingStatus = async (online) => {
  const { data } = await axios.patch(
    `${API}/admin/booking-status`,
    { online },
    { headers: authHeader() }
  );
  return !!data.online;
};

export const adminListModelBlocks = async () => {
  const { data } = await axios.get(`${API}/admin/model-blocks`, {
    headers: authHeader(),
  });
  return data;
};

export const adminCreateModelBlock = async (model, start_dt, end_dt, reason) => {
  const { data } = await axios.post(
    `${API}/admin/model-blocks`,
    { model, start_dt, end_dt, reason: reason || null },
    { headers: authHeader() }
  );
  return data;
};

export const adminDeleteModelBlock = async (id) => {
  await axios.delete(`${API}/admin/model-blocks/${encodeURIComponent(id)}`, {
    headers: authHeader(),
  });
};
